import { cleanCamelHash } from 'utils/questionnaireUtils';

export default function initialValuesFromQuestionnaire(questionnaire) {
  const vals = {};
  questionnaire.sections.forEach(s => {
    s.questions.forEach(q => {
      const value = q.answer || q.answers;
      if (value) {
        vals[`${cleanCamelHash(s.title)}__${cleanCamelHash(q.prompt)}`] = value;
      }
    });
    vals[`${cleanCamelHash(s.title)}__notes`] = s.notes;
  });
  return vals;
}
